import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const useMeterEditing = (groupedMeters, setGroupedMeters) => {
  const { t } = useTranslation();
  const [editingMeters, setEditingMeters] = useState({});

  const handleEdit = (groupIndex, meterIndex, meter) => {
    const key = `${groupIndex}-${meterIndex}`;
    setEditingMeters({ ...editingMeters, [key]: { ...meter } });
  };

  const handleCancelEdit = (meterKey) => {
    const newEditingMeters = { ...editingMeters };
    delete newEditingMeters[meterKey];
    setEditingMeters(newEditingMeters);
  };

  const handleFieldChange = (meterKey, field, value) => {
    setEditingMeters({
      ...editingMeters,
      [meterKey]: { ...editingMeters[meterKey], [field]: value }
    });
  };

  const validateMeter = (meter) => {
    const requiredFields = ['periodStart', 'periodEnd', 'contribution', 'contributionUnit'];

    for (const field of requiredFields) {
      const value = meter[field];
      if (!value || value === '—' || value.toString().trim() === '') {
        toast.error(t('Please complete all required fields'));
        return false;
      }
    }

    if (new Date(meter.periodStart) > new Date(meter.periodEnd)) {
      toast.error(t('Period Start Date must not be after Period End Date'));
      return false;
    }

    const contributionValue = parseFloat(meter.contribution);
    if (isNaN(contributionValue) || contributionValue < 0) {
      toast.error(t('Contribution must be numeric and equal to or greater than 0'));
      return false;
    }

    return true;
  };

  const handleSaveMeterEdit = (groupIndex, meterIndex) => {
    const meterKey = `${groupIndex}-${meterIndex}`;
    const editingData = editingMeters[meterKey];

    if (!editingData || !validateMeter(editingData)) {
      return;
    }

    const newGroups = [...groupedMeters];
    newGroups[groupIndex].meters[meterIndex] = { ...editingData };
    setGroupedMeters(newGroups);

    const newEditingMeters = { ...editingMeters };
    delete newEditingMeters[meterKey];
    setEditingMeters(newEditingMeters);
  };

  return {
    editingMeters,
    handleEdit,
    handleCancelEdit,
    handleFieldChange,
    handleSaveMeterEdit,
    validateMeter
  };
};

export default useMeterEditing;
